require('./blocks/about-promo.less');
require('./blocks/benefits/benefits');
require('./blocks/benefit.less');
require('./blocks/map-block.less');
require('./blocks/feedback-city/feedback-city');


// WEBPACK FOOTER //
// ./contacts.js